import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingCount = 0;
  isLoading$ = new BehaviorSubject<boolean>(false);

  show() {
    this.loadingCount++;
    this.isLoading$.next(true);
  }

  hide() {
    this.loadingCount--;
    if (this.loadingCount <= 0) {
      this.loadingCount = 0;
      this.isLoading$.next(false);
    }
  }

  reset() {
    this.loadingCount = 0;
    this.isLoading$.next(false);
  }
}